export function sphericalToCartesian({ r, theta, phi }) {
    return {
        x: r * Math.cos(phi) * Math.sin(theta),
        y: r * Math.sin(phi) * Math.sin(theta),
        z: r * Math.cos(theta)
    };
}
export function cartesianToSpherical({ x, y, z }) {
    const r = Math.sqrt(x * x + y * y + z * z);
    return {
        r,
        theta: Math.acos(z / r),
        phi: Math.atan2(y, x)
    };
}
export function sphericalToCartesianThreeJs(sphericalCoordinate) {
    const r = sphericalCoordinate.r;
    const theta = sphericalCoordinate.theta;
    const phi = sphericalCoordinate.phi + Math.PI / 2;
    return {
        x: r * Math.sin(theta) * Math.sin(phi),
        y: r * Math.cos(theta),
        z: r * Math.sin(theta) * Math.cos(phi),
    };
}
export function interpolateSphericalCoordinates(first, second, newElements) {
    const cartesianFirst = sphericalToCartesian(first);
    const cartesianSecond = sphericalToCartesian(second);
    const cartesianDelta = {
        x: cartesianSecond.x - cartesianFirst.x,
        y: cartesianSecond.y - cartesianFirst.y,
        z: cartesianSecond.z - cartesianFirst.z
    };
    let cartesianInterpolated = [];
    for (let i = 0; i < newElements; i++) {
        const λ = (i + 1) / (newElements + 1);
        cartesianInterpolated.push({
            x: cartesianFirst.x + λ * cartesianDelta.x,
            y: cartesianFirst.y + λ * cartesianDelta.y,
            z: cartesianFirst.z + λ * cartesianDelta.z
        });
    }
    const cartesianInterpolatedNormalised = cartesianInterpolated.map(({ x, y, z }) => {
        const norm = Math.sqrt(x * x + y * y + z * z);
        return {
            x: x / norm,
            y: y / norm,
            z: z / norm
        };
    });
    const sphericalInterpolated = cartesianInterpolatedNormalised.map(cartesianToSpherical);
    const result = [first].concat(sphericalInterpolated);
    result.push(second);
    return result;
}
export function increaseResolution(sphericalCoordinates, newElements, optimise = false) {
    let interpolated = [];
    for (let i = 0; i < sphericalCoordinates.length - 1; i++) {
        const first = sphericalCoordinates[i];
        const second = sphericalCoordinates[i + 1];
        let elements = newElements;
        if (optimise) {
            const cartesianFirst = sphericalToCartesian({ r: 1.0, theta: first.theta, phi: first.phi });
            const cartesianSecond = sphericalToCartesian({ r: 1.0, theta: second.theta, phi: second.phi });
            const x = cartesianSecond.x - cartesianFirst.x;
            const y = cartesianSecond.y - cartesianFirst.y;
            const z = cartesianSecond.z - cartesianFirst.z;
            const λ = Math.sqrt(x * x + y * y + z * z);
            elements *= λ;
        }
        interpolated = interpolated.concat(interpolateSphericalCoordinates(first, second, elements));
    }
    interpolated.push(sphericalCoordinates[sphericalCoordinates.length - 1]);
    return interpolated;
}
